<template>
  <b-row class="content-element animated fadeIn">
    <b-col style="padding:0" class="parrafo-edit">
      <ckeditor :editor="editor" v-model="dataEditor" :config="editorConfig"></ckeditor>
    </b-col>
    <!-- componente de botón de opciones del elemento  -->
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
  </b-row>
</template>
<script>
import InlineEditor from "@ckeditor/ckeditor5-build-inline/build/ckeditor";
import OptionsElement from "./OptionsElement";
export default {
  name: "Parrafo",
  props: {
    content: {
      type:String,
      default: ''//no toma los valores porque está embebido--ver bien el porqué
    },
    idElement: { type: Number }, // Se obtiene posición en el arreglo matriz
    idColumn: { type: Number, default: null } // se obtiene posición de la columna en caso de que esté posicionada en una
  },
  components: { OptionsElement },
  data() {
    return {
      editor: InlineEditor,
      dataEditor: this.content,
      editorConfig: {
        // Configuración del toolbar del editor de texto,
        fontSize: {
          options: [9, 11, 13, "default", 17, 19, 21]
        },
        fontFamily: {
          options:['default', 'Arial, Helvetica, sans-serif', 'Courier New, Courier, monospace', 'Georgia, serif','Lucida Sans Unicode, Lucida Grande, sans-serif', 'Tahoma, Geneva, sans-serif', 'Times New Roman, Times, serif','Trebuchet MS, Helvetica, sans-serif','Verdana, Geneva, sans-serif']
        },
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "insertTable",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "alignment",
          "fontSize",
          "fontFamily",
          "fontColor",
          "fontBackgroundColor"
        ],
        placeholder: "Agregue Texto" //falta agregar opciones de edición de texto
      }
    };
  },
  watch: {
    dataEditor: function(aft) {
      // se actualiza en el $store el contendio del parrafo con referencia a su posición en el arreglo matriz y si está posicionado dentro de una columna.
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: aft,
        field: "content",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>
<style lang="scss">
.btn-constructor-manage-element {
  position: absolute;
  right: -1.5rem;
  top: 0.3rem;
}
.parrafo-edit {
  p,
  h2,
  h3,
  h4:hover {
    cursor: text;
  }

  &:hover {
    cursor: grab;
  }
}
.ck-focused{
  border: none !important;
  box-shadow: none !important;
}
.ck-content{
  p{
    margin: 1px !important;
  }
}
</style>